import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import DataWrapper from '../../principal/containers/DataWrapper';
import {Row, Col, FormGroup, Label, Input} from 'reactstrap';
import {TabelaCadastro} from "../components/TabelaCadastro";
import AcheStore from "../stores/AcheStore";
import NumberFormat from 'react-number-format';
import {createSelectOptions, formatarReal, inteiroPositivo} from "../../../utils/formatar";
import Select from "react-select";
import {Validacao} from "../../comum/components/Validacao";

@inject("store")
@DataWrapper
@observer
export class CadastroAche extends Component {
    constructor(props) {
        super(props);
        this.modal                      = this.props.store.modalStore;
        this.appStore                   = this.props.store.appStore;
        this.tituloPaginaStore          = this.props.store.tituloPaginaStore;
        /* Selecionar Controller */
        this.controller                 = new AcheStore(this.modal);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Ache");

        this.controller.carregarLista();
    }

    /* modais (body e botões) */
    modalForm = () => {
        const empresaGloboOptions = createSelectOptions(this.controller.empresasGlobo.filter(item => item.ativo), "id", ["nome"]);
        const sindicatoOptions = this.controller.sindicatos;
        return(
            <div>
                <Row>
                    <Col xs={12} md={6} lg={6}>
                        <FormGroup>
                            <Label>Unidade de negócio (BU) <sup>*</sup></Label>
                            <Select simpleValue  value={this.controller.itemSelecionado.empresaGloboId} options={empresaGloboOptions}
                                    onChange={(value) => this.controller.setEmpresaGloboId(value)} multi={false} placeholder="Selecione..." noResultsText="Nenhum resultado encontrado" />
                            <Validacao id="empresaGloboId" valor={this.controller.itemSelecionado.empresaGloboId} tipo={["isRequired"]} />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={6}>
                        <FormGroup>
                            <Label>Categoria <sup>*</sup></Label>
                            <Select simpleValue  value={this.controller.itemSelecionado.sindicato} options={sindicatoOptions}
                                    onChange={(value) => this.controller.setSindicato(value)} multi={false} placeholder="Selecione..." noResultsText="Nenhum resultado encontrado" />
                            <Validacao id="sindicato" valor={this.controller.itemSelecionado.sindicato} tipo={["isRequired"]} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <FormGroup check >
                            <Label check>
                                <Input type="checkbox" checked={this.controller.itemSelecionado.aplicarAche} onChange={() => this.controller.toggleAplicarAche()} />{' '}
                                <Label>Aplica Ache</Label>
                            </Label>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={6}>
                        <FormGroup>
                            <Label>Percentual Ache <sup>*</sup></Label>
                            <Validacao id="percentualAche" valor={this.controller.itemSelecionado.percentualAche} tipo={this.controller.itemSelecionado.aplicarAche && ["isRequired"]} >
                                <NumberFormat suffix="%" maxLength={10} allowNegative={false} className="form-control" decimalPrecision={4} value={this.controller.itemSelecionado.percentualAche} onChange={(event, values) => this.controller.setPercentualAche(values.floatValue)} disabled={!this.controller.itemSelecionado.aplicarAche}/>
                            </Validacao>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={6}>
                        <FormGroup>
                            <Label>Percentual salário <sup>*</sup></Label>
                            <NumberFormat suffix="%" maxLength={10} allowNegative={false} className="form-control" decimalPrecision={4} value={this.controller.itemSelecionado.percentualSalarioBase} onChange={(event, values) => this.controller.setPercentualSalarioBase(values.floatValue)} />
                            <Validacao id="percentualSalario" valor={this.controller.itemSelecionado.percentualSalarioBase} tipo={this.controller.itemSelecionado.aplicarAche && ["isRequired"]} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={6}>
                        <FormGroup>
                            <Label>Jornada Contratual <sup>*</sup></Label>
                            <Input type="number" readOnly={this.modal.exibirModal.tipo == "editar"} value={this.controller.itemSelecionado.jornadaContratual} onChange={(event) => this.controller.setJornadaContratual(inteiroPositivo(event.target.value))} />
                            <Validacao id="jornadaContratual" valor={this.controller.itemSelecionado.jornadaContratual} tipo={["isRequired"]} />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={6}>
                        <FormGroup>
                            <Label>Jornada Ache <sup>*</sup></Label>
                            <Input type="number" readOnly={this.modal.exibirModal.tipo == "editar"} value={this.controller.itemSelecionado.jornadaAche} onChange={(event) => this.controller.setJornadaAche(inteiroPositivo(event.target.value))} />
                            <Validacao id="jornadaAche" valor={this.controller.itemSelecionado.jornadaAche} tipo={["isRequired"]} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={6}>
                        <FormGroup>
                            <Label>Jornada Contratual + Ache</Label>
                            <Input type="number" value={this.controller.itemSelecionado.jornadaAche+this.controller.itemSelecionado.jornadaContratual} readOnly />
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    };

    obterTituloMobile = (objeto) => {
        return  objeto.sindicato ? objeto.sindicato + " - " + objeto.empresaGlobo.nome : objeto.empresaGlobo.nome;
    };

    obterConteudoMobile = (objeto) => {
        const aplicarAche = objeto.aplicarAche ? "Sim" : "Não";
        const percentualAche = objeto.percentualAche ? objeto.percentualAche+"%" : "";
        const percentualSalario = objeto.percentualSalarioBase ? objeto.percentualSalarioBase+"%" : "";
        return (
            <div>
                { "Aplica Ache: " + aplicarAche}<br/>
                { "Percentual Ache: " + percentualAche}<br/>
                { "Percentual para calcular salário base: " + percentualSalario}<br/>
            </div>
        )
    };

    nomeFormat(cell) {
        return cell ? cell.nome : "";
    }

    empresaGloboFormat(cell) {
        if(cell) {
            return cell && cell.nome ? cell.nome : "";
        }
    }

    jornada(cell, row) {
        return row ? row.jornadaContratual+row.jornadaAche : 0;
    }

    render() {
        const colunas = [
            {
                field: "empresaGlobo",
                dataFormat: this.empresaGloboFormat,
                label: "Unidade de negócio (BU)"
            },{
                field: "sindicato",
                label: "Categoria"
            },{
                field: "aplicarAche",
                label: "Aplica Ache",
                type: "boolean"
            },{
                field: "percentualAche",
                label: "Percentual Ache",
                type: "percentage"
            },{
                field: "percentualSalarioBase",
                label: "Percentual salário",
                type: "percentage"
            },{
                field: "jornadaContratual",
                label: "Jornada Contratual"
            },{
                field: "jornadaAche",
                label: "Jornada Ache"
            },{
                field: "",
                label: "Jornada Contratual + Ache",
                dataFormat: this.jornada,
            }
        ];

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel panel-sm" : "panel-sm"}>
                        <TabelaCadastro
                            nomeCadastro={'Ache'}
                            listaItens={this.controller.acheLista}
                            onChange={(value) => this.controller.setLista(value)}
                            colunas={colunas}
                            temBusca={true}
                            criarNovos={true}
                            modalEditar={this.modalForm()}
                            modalCadastrar={this.modalForm()}
                            preencherModal={(row) => this.controller.preencherModal(row)}
                            editar={() => this.controller.editar()}
                            cadastrar={() => this.controller.cadastrar()}
                            remover={() => this.controller.remover()}
                            tituloMobile={(row) => this.obterTituloMobile(row)}
                            conteudoMobile={(row) => this.obterConteudoMobile(row)}
                            loading={this.controller.loading}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

